import React, { useState } from "react";
import { Button, Col, Form, InputGroup, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy } from "@fortawesome/free-solid-svg-icons";
import { HTTP_CLIENT } from "../../hooks";

interface Props {
  jwt: string;
}

export function GenerateJWT({ jwt }: Readonly<Props>) {
  const [subject, setSubject] = useState<string>("");
  const [token, setToken] = useState<string | undefined>();
  const [submitting, setSubmitting] = useState<boolean>(false);

  const onSubmit = async () => {
    setSubmitting(true);
    try {
      const response = await HTTP_CLIENT.get<{ token: string }>({
        path: "/api/v2/auth/token",
        query: { subject: subject.trim() },
        headers: { Authorization: `Bearer ${jwt}` },
      });
      setToken(response.token);
    } catch (e: any) {
      console.error(e.stack);
      toast.error("Failed to generate JWT!");
      setToken(undefined);
    } finally {
      setSubmitting(false);
    }
  };

  const onCopy = async () => {
    if (!token) return;
    try {
      await navigator.clipboard.writeText(token);
      toast.success("JWT copied to clipboard");
    } catch (e: any) {
      console.error(e.stack);
      toast.error("Failed to copy JWT to clipboard");
    }
  };

  return (
    <>
      <Row>
        <Col>
          <h1>Generate JWT</h1>
        </Col>
      </Row>

      <Row>
        <Col md={8} lg={6}>
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              void onSubmit();
            }}
          >
            <Form.Group className="mb-3" controlId="generateJwtSubject">
              <Form.Label>
                Subject <span style={{ color: "red" }}>*</span>
              </Form.Label>
              <Form.Control
                aria-label="subject"
                type="text"
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
                placeholder="Enter unique identifiable subject"
                required
              />
            </Form.Group>

            <Button
              variant="primary"
              type="submit"
              disabled={!subject.trim() || submitting}
            >
              {submitting ? "Generating..." : "Generate JWT"}
            </Button>
          </Form>
        </Col>
      </Row>

      {token && (
        <Row className="mt-4">
          <Col md={8} lg={6}>
            <Form.Label>Generated JWT</Form.Label>
            <InputGroup>
              <Form.Control
                as="textarea"
                aria-label="generatedJwt"
                value={token}
                readOnly
                rows={5}
                style={{ fontFamily: "monospace", wordBreak: "break-all" }}
              />
              <Button
                variant="outline-secondary"
                onClick={onCopy}
                aria-label="copyJwt"
                title="Copy JWT"
              >
                <FontAwesomeIcon icon={faCopy} /> Copy
              </Button>
            </InputGroup>
          </Col>
        </Row>
      )}
    </>
  );
}
